import { useTranslation } from "react-i18next";

const statusOptions = (list) => {
  const { t } = useTranslation();
  const options = [
    {
      key: "approved",
      title: t("options.status.approved"),
      value: "APPROVED",
    },
    {
      key: "waiting",
      title: t("options.status.waiting"),
      value: "WAITING",
    },
    {
      key: "rejected",
      title: t("options.status.rejected"),
      value: "REJECTED",
    },
    {
      key: "active",
      title: t("options.status.active"),
      value: "ACTIVE",
    },
    {
      key: "suspended",
      title: t("options.status.suspended"),
      value: "SUSPENDED",
    },
  ];

  if (typeof list === "string" && list.toLowerCase() === "all") {
    return options;
  }
  if (Array.isArray(list)) {
    const newOptions = [];
    for (const item of list) {
      const newOption = options.find(
        (option) => item === option.value || item === option.key.toLowerCase(),
      );
      newOptions.push(newOption);
    }
    return newOptions;
  }
  return [];
};

export default statusOptions;
